import React from "react";

function ToggleSwitch({ toggleOutput, currentToggled, label, disabled = false }) {
  return (
    <div className="toggle-switch-outer">
      {/* Left: Toggle + Label */}
      <label
        className="toggle-switch-label"
        onClick={disabled ? undefined : toggleOutput}
        style={{
          cursor: disabled ? "not-allowed" : "pointer",
        }}
      >
        {/* Custom Toggle Switch */}
        <div
          className="toggle-switch-container"
          style={{
            backgroundColor: currentToggled ? "var(--primary-color)" : "#ccc",
            cursor: disabled ? "not-allowed" : "pointer",
          }}
        >
          <div
            className="toggle-switch-circle"
            style={{
              left: currentToggled ? "18px" : "2px",
            }}
          />
        </div>

        {/* Label Text */}
        <span className="toggle-switch-text">{label}</span>
      </label>
    </div>
  );
}

export default ToggleSwitch;
